export default __webpack_public_path__ + "static/media/port_icon_selected.cf8d765d.svg";